"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInputTypeWithArrayValue = exports.isGroupedChoice = void 0;
const isGroupedChoice = (choice) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof choice.groupShortname === 'string';
};
exports.isGroupedChoice = isGroupedChoice;
const inputTypesWithArrayValue = ['checkbox', 'multiselect'];
const isInputTypeWithArrayValue = (inputType) => inputTypesWithArrayValue.includes(inputType);
exports.isInputTypeWithArrayValue = isInputTypeWithArrayValue;
//# sourceMappingURL=WidgetConfig.js.map